import { ActionResponse } from "../../../components/AddItemForm/types"
import { InputError } from "../../../components/Input/types"
import { closeModal } from "../../../contexts/ModalContext/actions"
import i18n from "../../../i18n"
import { createServiceBase, createServiceInstance, removeServiceInstanceAttachment, updateServiceBase, updateServiceInstance } from "../../../services/calls/maintenance"
import { DTO_MaintenanceMobile, Entity_ServiceBase } from "../../../services/calls/types/maintenance"
import { objToFormData } from "../../../services/utils/convert"
import { findArrayChange } from "../../../services/utils/misc"
import { isValidEmail } from "../../../services/utils/validation"
import { DateTime } from "luxon"

export const saveServiceBase = async (data: Entity_ServiceBase, id?: number): Promise<ActionResponse> => {
  // Validate data
  let isValid = true
  const error: Record<string, InputError> = {}

  if (data?.emails?.length && isValid) {
    data.emails?.forEach((email: string) => {
      if (!isValid) return false
      isValid = isValidEmail(email)
    })

    if (!isValid) {
      error.emails = {
        type: 'error',
        message: i18n.t('Not all emails are valid')
      }
    }
  }

  const formatData = {
    ...data,
    first: data.first ? data.first * 1000 : undefined,
    interval: data.interval ? data.interval * 1000 : undefined,
    enabled: true,
    emails: data.emails?.map((email) => ({ email })) ?? []
  }

  if (isValid) {
    let resp
    if (id) resp = await updateServiceBase(id, formatData)
    else resp = await createServiceBase(formatData)
    
    closeModal()
    return {
      status: 'success',
      data: resp
    }
  }

  return {
    status: 'error',
    data: error
  }
}

export const saveScheduleInstance = async (data: any, id?: number, oldData?: any): Promise<ActionResponse> => {
  // Validate data
  let isValid = true
  const error: Record<string, InputError> = {}

  if (!id && !data.description) {
    error.description = {
      type: 'error',
      message: i18n.t('Description is required')
    }
  }

  const newData = {
    ...data,
    date: DateTime.fromISO(data.date).toISODate(),
    actual_value: data.actual_value ? data.actual_value * 1000 : undefined
  }

  // Add/remove attachments
  if (data.service_instance_attachments?.length || oldData?.service_instance_attachments?.length) {
    const filesToUpload = data.service_instance_attachments.filter((file) => !file.id)
    if (filesToUpload.length) newData.upload_attachments = filesToUpload

    // Check if attachment has been deleted
    const oldAttachments = oldData.service_instance_attachments
      .filter((file) => file.id)
      .map((file) => file.id)
    const currentAttachments = data.service_instance_attachments
      .filter((file) => file.id)
      .map((file) => file.id)
    const changes = findArrayChange(currentAttachments, oldAttachments)
    if (changes.remove) {
      changes.remove.forEach((fileId) => {
        removeServiceInstanceAttachment(fileId)
      })
    }
  }

  const formData = objToFormData(newData, true)
  if (isValid) {
    let resp
    if (id) resp = await updateServiceInstance(id, formData)
    else resp = await createServiceInstance(formData)

    closeModal()
    return {
      status: 'success',
      data: resp
    }
  }

  return {
    status: 'error',
    data: error
  }
}
